// Import model
import { PrepareUploadResponse } from '../models/PrepareUploadResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PrepareUploadResponse - handles JSON serialization and deserialization with type validation
 */
export class PrepareUploadResponseSerializer {
  /**
   * Deserializes a JSON string into a PrepareUploadResponse instance
   */
  static deserialize(json: string): PrepareUploadResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PrepareUploadResponse instance
   */
  static fromObject(obj: any): PrepareUploadResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PrepareUploadResponse');
    }


    const instance: PrepareUploadResponse = {
      message: obj['Message'] as string | undefined,
      success: obj['Success'] as boolean,
      url: obj['Url'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PrepareUploadResponse instances
   */
  static deserializeArray(json: string): PrepareUploadResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PrepareUploadResponse instance to a JSON string
   */
  static serialize(instance: PrepareUploadResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PrepareUploadResponse instance to a plain object
   */
  static toObject(instance: PrepareUploadResponse): any {
    return {
      'Message': instance.message,
      'Success': instance.success,
      'Url': instance.url,
    };
  }

  /**
   * Serializes an array of PrepareUploadResponse instances to a JSON string
   */
  static serializeArray(instances: PrepareUploadResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
